import { Injectable } from '@angular/core';
import { GenericService } from '../../../../core/services/GenericService';
import { IEvent } from '../interfaces';
import { ApiService } from '../../../../core/services';
import { Observable } from 'rxjs';
import { ISimpleListItem } from '../../../../core/interfaces/ISimpleListItem';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SeminarsEventsService extends GenericService<IEvent> {

  protected readonly baseUrl = '/seminars/events';

  public constructor(
    public readonly apiService: ApiService
  ) {
    super(apiService);
  }

  public archiveEvent(eventId: number): Observable<void> {
    return this.apiService.post(`${ this.baseUrl }/${ eventId }/archive`);
  }

  public getSimpleList(search = ''): Observable<ISimpleListItem[]> {
    const params = new HttpParams()
      .append('search', `${search}`);
    return this.apiService.get(`${this.baseUrl}/simple`, params);
  }
}
